import api from '@/apis/sa/sASaleInvoiceCancelAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('sASaleInvoiceCancel', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sa_sale_invoice',
    field: {
      key: 'ref_id',
    },
  },
  loadDataDetail: false,
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,

  /**
   * Cập nhật dữ liệu biến loadDataDetail
   * TTLONG 28/09/2022
   */
  setLoadDataDetail(context, data) {
    context.loadDataDetail = data;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
